export default __webpack_public_path__ + "static/media/Snd2.d7013a74.mp3";